import React from "react";
import { Button } from "./MuiGenerals";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";

const RedirectCellButton = ({ onClick }: { onClick: () => void }) => {
  return (
    <Button onClick={onClick} color="secondary" variant="contained">
      <OpenInNewIcon />
    </Button>
  );
};

export default RedirectCellButton;
